import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {NameInfoAccordionViewProps} from './model';
import {images} from '../../../../../assets/icons';
import {Container} from '../../../../../shared/components/container';
import {useTheme} from '../../../../../shared/theme';
import getStyles from './styles';
import {capitalizeLastWord} from '../../../../../shared/utils/text';

export default ({title, expanded, onPress, children}: NameInfoAccordionViewProps) => {
  const theme = useTheme();
  const styles = getStyles();

  const {Left: Arrow} = images;

  return (
    <Container style={styles.container}>
      <TouchableOpacity style={styles.touchEnableHeader} onPress={onPress} activeOpacity={1}>
        <View style={styles.header}>
          <Text style={styles.title}>{capitalizeLastWord(title)}</Text>
          <View style={[styles.arrow, expanded ? styles.arrowActive : null]}>
            <Arrow width={20} height={20} color={theme.header.iconsColor} />
          </View>
        </View>
      </TouchableOpacity>
      {expanded ? <View style={styles.description}>{children}</View> : null}
    </Container>
  );
};
